exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disable-scroll{overflow:hidden!important}.closeSearchDesktop{top:15px!important}", ""]);

// exports
